<template>
  <div class="index-section-box borderbox" v-if="items.length > 0">
    <div class="index-section-title">
      <div class="index-section-title-text">推荐课程</div>
      <div class="more" @click="goCourse">
        <span>查看更多</span>
      </div>
    </div>
    <div class="index-section-body">
      <div
        class="topic-item"
        @click="goCourseDetail(item.id)"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="vod-course-item-comp">
          <div class="vod-course-thumb">
            <img :src="item.coverUri" />
          </div>
          <div class="vod-course-body">
            <div class="vod-course-title">
              {{ item.title }}
            </div>
            <div class="vod-course-info">
              <div class="vod-course-sub">{{ item.categoryName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items"],
  methods: {
    goCourse() {
      this.$router.push({
        name: "Course",
      });
    },
    goCourseDetail(id) {
      this.$router.push({ name: "CourseDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.index-section-box {
  width: 100%;
  margin-top: 10px;
  background: #ffffff;
  padding: 25px 15px 20px 15px;
  display: flex;
  flex-direction: column;
  .index-section-title {
    width: 100%;
    height: 19px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .index-section-title-text {
      height: 19px;
      font-size: 19px;
      font-weight: 600;
      color: #333333;
      line-height: 19px;
    }
    .more {
      display: inline-block;
      width: auto;
      height: 13px;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 13px;
      cursor: pointer;
    }
  }
  .index-section-body {
    width: 100%;
    .topic-item {
      width: 100%;
      display: flex;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}

.topic-item {
  width: 100%;
  display: flex;
  margin-bottom: 30rpx;
}

.vod-course-item-comp {
  width: 100%;
  height: auto;
  float: left;
  display: flex;
}

.vod-course-thumb {
  width: 120px;
  height: 90px;
  margin-right: 10px;
}

.vod-course-thumb img {
  width: 120px;
  height: 90px;
  border-radius: 4px;
}

.vod-course-body {
  flex: 1;
  padding-top: 5px;
}

.vod-course-title {
  width: 100%;
  height: 40px;
  float: left;
  font-size: 15px;
  font-weight: 500;
  color: #171923;
  line-height: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 15px;
}

.vod-course-info {
  width: 100%;
  height: auto;
  float: left;
  display: flex;
  align-items: center;
}

.vod-course-sub {
  flex: 1;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
}
</style>
